/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AmdSetting {
  DEFAULT = "DEFAULT",
  DISABLED = "DISABLED",
}

export enum ApprovalRequirement {
  ALL = "ALL",
  NONE = "NONE",
  NON_LANDLINE = "NON_LANDLINE",
}

export enum CallStatus {
  ANSWERING_MACHINE = "ANSWERING_MACHINE",
  ANSWERING_MACHINE_IN_PROGRESS = "ANSWERING_MACHINE_IN_PROGRESS",
  BUSY = "BUSY",
  COMPLETED = "COMPLETED",
  CONNECTED = "CONNECTED",
  DECLINED = "DECLINED",
  ERROR = "ERROR",
  FAILED = "FAILED",
  HUNGUP = "HUNGUP",
  IN_PROGRESS = "IN_PROGRESS",
  NO_ANSWER = "NO_ANSWER",
  VOICEMAIL_DROP = "VOICEMAIL_DROP",
}

export enum CalleeField {
  ADDRESS_LINE_1 = "ADDRESS_LINE_1",
  ADDRESS_LINE_2 = "ADDRESS_LINE_2",
  CITY = "CITY",
  EMAIL = "EMAIL",
  FIRST_NAME = "FIRST_NAME",
  LAST_NAME = "LAST_NAME",
  POLLING_PLACE_ADDRESS_LINE_1 = "POLLING_PLACE_ADDRESS_LINE_1",
  POLLING_PLACE_CITY = "POLLING_PLACE_CITY",
  POLLING_PLACE_NAME = "POLLING_PLACE_NAME",
  POLLING_PLACE_STATE = "POLLING_PLACE_STATE",
  STATE = "STATE",
  ZIP = "ZIP",
}

export enum CallerStatus {
  COMPLETE = "COMPLETE",
  CONNECTED = "CONNECTED",
  IN_CALL = "IN_CALL",
  IN_QUEUE = "IN_QUEUE",
  IN_SURVEY = "IN_SURVEY",
}

export enum CampaignSortBy {
  CREATED_AT = "CREATED_AT",
  NAME = "NAME",
}

export enum CampaignStatus {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
  COMPLETE = "COMPLETE",
  DRAFT = "DRAFT",
  PAUSED = "PAUSED",
  PAUSING = "PAUSING",
  PERMANENTLY_ARCHIVED = "PERMANENTLY_ARCHIVED",
  STALLED = "STALLED",
}

export enum ExportType {
  BIGQUERY = "BIGQUERY",
  S3 = "S3",
}

export enum FeatureToggleType {
  DEFAULT = "DEFAULT",
  OFF = "OFF",
  ON = "ON",
}

export enum JobSortBy {
  CREATED_AT = "CREATED_AT",
}

export enum JobStatus {
  CREATED = "CREATED",
  DONE = "DONE",
  FAILED = "FAILED",
  QUEUED = "QUEUED",
  RUNNING = "RUNNING",
}

export enum JobType {
  CAMPAIGN_CONTACTS_UPLOAD = "CAMPAIGN_CONTACTS_UPLOAD",
  CAMPAIGN_EXPORT = "CAMPAIGN_EXPORT",
  CAMPAIGN_START = "CAMPAIGN_START",
  CAMPAIGN_VAN_SAVED_LIST_IMPORT = "CAMPAIGN_VAN_SAVED_LIST_IMPORT",
  CONFIGURE_MESSAGING_NUMBER = "CONFIGURE_MESSAGING_NUMBER",
  OPT_OUT_BULK_DELETE = "OPT_OUT_BULK_DELETE",
  OPT_OUT_UPLOAD = "OPT_OUT_UPLOAD",
  S3_EXPORT = "S3_EXPORT",
}

export enum MessagingPhoneNumberStatus {
  active = "active",
  expired = "expired",
  tollfree = "tollfree",
  unregistered = "unregistered",
}

export enum OptOutSortBy {
  CREATED_AT = "CREATED_AT",
}

export enum PollingPlaceLookupTool {
  IWILLVOTE = "IWILLVOTE",
}

export enum QuestionType {
  DISPOSITION = "DISPOSITION",
  MOBILIZEAMERICA_RSVP = "MOBILIZEAMERICA_RSVP",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  PATCH_THRU = "PATCH_THRU",
  POLLING_PLACE_LOOKUP = "POLLING_PLACE_LOOKUP",
  SEND_MESSAGE = "SEND_MESSAGE",
  SINGLE_CHOICE = "SINGLE_CHOICE",
  TEXT_FIELD = "TEXT_FIELD",
}

export enum Role {
  ADMIN = "ADMIN",
  OWNER = "OWNER",
  TENANT_OWNER = "TENANT_OWNER",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum UploadType {
  CAMPAIGN_CONTACTS = "CAMPAIGN_CONTACTS",
  CAMPAIGN_VOICEMAIL = "CAMPAIGN_VOICEMAIL",
  OPT_OUTS = "OPT_OUTS",
}

export enum UploadVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
}

export enum VanDatabaseMode {
  MY_CAMPAIGN = "MY_CAMPAIGN",
  MY_VOTERS = "MY_VOTERS",
}

export enum VanProxySearchType {
  ACTIVIST_CODE = "ACTIVIST_CODE",
  SAVED_LIST = "SAVED_LIST",
  SURVEY_QUESTION = "SURVEY_QUESTION",
}

export interface BlockedPhoneNumberFilterInput {
  phoneNumberContains?: string | null;
}

export interface CalleeAdditionalInfoInput {
  name: boolean;
  phoneNumber: boolean;
  homeAddress: boolean;
  pollingPlace: boolean;
}

export interface CampaignAnswerInput {
  key: string;
  value: string;
  next?: string | null;
  disposition?: string | null;
  vanIntegrationSettings?: CampaignAnswerVanIntegrationSettingsInput | null;
  patchThruConfig?: CampaignAnswerPatchThruConfigInput | null;
}

export interface CampaignAnswerPatchThruConfigInput {
  fixedNumber?: string | null;
}

export interface CampaignAnswerVanIntegrationSettingsInput {
  activistCodeId?: number | null;
  surveyResponseId?: number | null;
  resultCodeId?: number | null;
}

export interface CampaignCallingHoursInput {
  startTime: string;
  endTime: string;
  timezone: string;
}

export interface CampaignCreateCalleeFieldInput {
  name: string;
  dataSourceFieldName?: string | null;
  builtInField?: CalleeField | null;
}

export interface CampaignDefaultsInput {
  campaignDefaultAreaCode: string;
  campaignCallerPhoneInAreaCode?: string | null;
  campaignDefaultCallingHours: CampaignCallingHoursInput;
  customer_profile_sid?: string | null;
  approved_stir_shaken_sid?: string | null;
  approved_voice_integrity_sid?: string | null;
  approved_branded_calling_sid?: string | null;
  approved_branded_calling_basic_sid?: string | null;
  approval_requirement: ApprovalRequirement;
  voicemail_allowed: boolean;
  defaultProvider?: string | null;
}

export interface CampaignEditCalleeFieldInput {
  name: string;
  dataSourceFieldName?: string | null;
}

export interface CampaignFilterInput {
  nameContains?: string | null;
  statusIn?: CampaignStatus[] | null;
}

export interface CampaignIntegrationInput {
  vanIntegrationId: string;
  databaseMode: VanDatabaseMode;
}

export interface CampaignQuestionInput {
  key: string;
  name: string;
  script?: string | null;
  isRichText?: boolean | null;
  questionType: QuestionType;
  answers: CampaignAnswerInput[];
  next?: string | null;
  vanIntegrationSettings?: CampaignQuestionVanIntegrationSettingsInput | null;
  mobilizeAmericaRsvpSettings?: CampaignQuestionMobilizeAmericaRsvpSettingsInput | null;
  sendMessageSettings?: CampaignQuestionSendMessageSettingsInput | null;
  pollingPlaceLookupSettings?: CampaignQuestionPollingPlaceLookupSettingsInput | null;
}

export interface CampaignQuestionMobilizeAmericaRsvpSettingsInput {
  eventId: number;
  mobilizeTenantSlug: string;
}

export interface CampaignQuestionPollingPlaceLookupSettingsInput {
  lookupTool: PollingPlaceLookupTool;
}

export interface CampaignQuestionSendMessageSettingsInput {
  text: string;
}

export interface CampaignQuestionVanIntegrationSettingsInput {
  surveyQuestionId: number;
}

export interface CampaignSortInput {
  sortBy?: CampaignSortBy | null;
  direction?: SortDirection | null;
}

export interface CampaignUploadContactsColumnMappingInput {
  phoneNumberColumn: string;
  vanIdColumnAndSettings?: CampaignUploadContactsVanIdMappingInput | null;
}

export interface CampaignUploadContactsVanIdMappingInput {
  column: string;
  integration: CampaignIntegrationInput;
}

export interface CustomCallerAlertInput {
  expiredAt?: string | null;
  message?: string | null;
}

export interface CustomEndMessageInput {
  onCompleteMessage?: string | null;
  onPausedMessage?: string | null;
  onOutOfHoursMessage?: string | null;
}

export interface JobSortInput {
  sortBy?: JobSortBy | null;
  direction?: SortDirection | null;
}

export interface OptOutFilterInput {
  phoneNumberContains?: string | null;
}

export interface OptOutSortInput {
  sortBy?: OptOutSortBy | null;
  direction?: SortDirection | null;
}

export interface TalkingPointsInput {
  heading?: string | null;
  text?: string | null;
}

export interface TenantExportBigQuerySettingsCreateInput {
  gcsBucket: string;
  gcsBucketPrefix: string;
  dataset: string;
  credentialsJSON: string;
  addTenantScoping: boolean;
}

export interface TenantExportBigQuerySettingsUpdateInput {
  gcsBucket: string;
  gcsBucketPrefix: string;
  dataset: string;
  credentialsJSON?: string | null;
}

export interface TenantExportS3SettingsCreateInput {
  bucket: string;
  prefix: string;
  awsRegion: string;
  awsAccessKeyId: string;
  awsSecretAccessKey: string;
  incremental: boolean;
}

export interface TenantExportS3SettingsUpdateInput {
  bucket: string;
  prefix: string;
  awsRegion: string;
  awsAccessKeyId: string;
  awsSecretAccessKey?: string | null;
  incremental: boolean;
}

export interface TenantFeatureFlagsInput {
  vanListImport?: boolean | null;
  mobilizeAmericaRsvp?: boolean | null;
  voicemailDrop?: boolean | null;
  sendMessageQuestionType?: boolean | null;
  patchThru?: boolean | null;
  multiplePasses?: boolean | null;
  usage?: boolean | null;
  adminsCanToggleAmd?: boolean | null;
  adminsCanTogglePhoneOnlyMode?: boolean | null;
  structuredDispositions?: boolean | null;
  customTwilioIntegration?: boolean | null;
  humanDetection?: boolean | null;
  sidebar?: boolean | null;
  disableClicker?: boolean | null;
  watermarkDialing?: boolean | null;
  alternateDropRate?: boolean | null;
  provisionUnassignedNumbers?: boolean | null;
  reuseNumbers?: boolean | null;
  bulkVanSync?: boolean | null;
  preventMessagingFromUnregisteredNumbers?: boolean | null;
  callerPhoneVerification?: boolean | null;
}

export interface TenantFeatureFlagsWithDefaultsInput {
  vanListImport?: FeatureToggleType | null;
  mobilizeAmericaRsvp?: FeatureToggleType | null;
  voicemailDrop?: FeatureToggleType | null;
  sendMessageQuestionType?: FeatureToggleType | null;
  patchThru?: FeatureToggleType | null;
  multiplePasses?: FeatureToggleType | null;
  usage?: FeatureToggleType | null;
  adminsCanToggleAmd?: FeatureToggleType | null;
  adminsCanTogglePhoneOnlyMode?: FeatureToggleType | null;
  structuredDispositions?: FeatureToggleType | null;
  customTwilioIntegration?: FeatureToggleType | null;
  humanDetection?: FeatureToggleType | null;
  sidebar?: FeatureToggleType | null;
  disableClicker?: FeatureToggleType | null;
  watermarkDialing?: FeatureToggleType | null;
  alternateDropRate?: FeatureToggleType | null;
  provisionUnassignedNumbers?: FeatureToggleType | null;
  reuseNumbers?: FeatureToggleType | null;
  bulkVanSync?: FeatureToggleType | null;
  preventMessagingFromUnregisteredNumbers?: FeatureToggleType | null;
  callerPhoneVerification?: FeatureToggleType | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
